<template>
  <div class="wrapper" ref="wrapper">
    <div class="header-wrapper">
      <div class="box">
        <div class="btn" @click="type = 'fabu'" :class="type == 'fabu'?'active':''">发布</div>
        <div class="btn" @click="type = 'caogao'" :class="type == 'caogao'?'active':''">草稿</div>
      </div>
      <div class="header">积分兑换</div>
      <Button class="bkcc-btn" @click="$router.push({name:'newExchange'})">发布</Button>
    </div>
    <good-card
      :activityList="goodList"
      :contentWidth="contentWidth"
      :isCaogao="type"
      @init="initList"
    ></good-card>
    <infinite-loading :identifier="newRule" @infinite="loadMore">
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>
  </div>
</template>

<script>
  import goodCard from '../components/goodCard'

  var that
  export default {
    name: 'pointsExchange',
    components: {
      goodCard
    },
    data() {
      return {
        type: 'fabu',//左上角切换按钮当前状态
        filterList: [],
        total: -1,
        newRule: 0,
        page: 1,
        rows: 20,
        title: '',
        status: '',
        communityIdList: [],
        goodList: [],
        contentWidth: 1510,
        statusList:[],

      }
    },
    watch: {
      /* 当前total发生变化时 右侧label显示跟着变化 */
      total(newVal) {
        console.log(newVal)
        this.$store.commit("updateLabelList", [
          {
            name: "filter_label",
            data: {
              label: "当前总人数",
              value: newVal
            }
          }
        ]);
      },
      type () {
        if (this.type == 'caogao') {
          this.status = ''
          this.communityIdList = []
        }
        this.initList()
        this.getfilter()
      }
    },
    methods: {
      loadMore(loadingContext) {
        this.getAllGoods(loadingContext);
      },
      getAllGoods(loadingContext) {
        var url = this.urlobj.getGoodsList;
        this
          .$get(url, {
            pageNumber: this.page,
            pageSize: this.rows,
            title: this.title,
            status: this.status,
            communityIdList: this.communityIdList,
            isSend: this.type == 'fabu' ? 1 : 0
          })
          .then(res => {
            this.total = String(res.total)
            if (res.rows.length) {
              this.page++;
              loadingContext.loaded(); // 结束加载状态
              var list = res.rows.map(item => {
                return {
                  status:item.status,//状态0--未开始，1--核销中，2--已结束
                  id:item.id,
                  cover:item.coverPicUrl,
                  title:item.title,
                  quantity: item.quantity,//商品数量,
                  orderNumber: item.orderNumber,//兑换数量,
                  consumeNumber: item.consumeNumber,//核销数量,
                }
              })
              this.goodList = this.goodList.concat(list)

            } else {
              /* 如果没有数据 完成加载 */
              loadingContext.complete();
            }
          });
      },
      initList() {
        this.page = 1;
        this.goodList = []
        this.newRule++
      },
      getfilter() {
        this.filterList = []
        var url = this.urlobj.getGoodsLabel
        this.$get(url,{
          isSend:this.type == 'fabu' ? 1 : 0
        }).then(res => {
          var filterData = []
          var num = 0
          var ids = []
          var counts = []
          ids = res.rows.map(item => {
            return item.communityId
          })
          counts = res.rows.map(item => {
            return item.count
          })
          counts.forEach(item => {
            num += item
          })
          var item1 = {
            name: '全部',
            id: ids.join(','),
            userCount: num
          }
          var list = res.rows.map(item => {
            return {
              name: item.communityName,
              id: item.communityId,
              userCount: item.count
            };
          })
          list.unshift(item1)
          //匹配默认选中index
          var index1 = -1
          list.forEach((item, index) => {
            if(item.id == this.$store.state.streetorcommunityid) {
              index1 = index
            }
          })
          console.log(list)
          filterData.push({
            type: "community",
            name: "行政区域",
            selectedIndex: 0,
            children: list
          });
          this.communityIdList = list[0].id
          for (const obj in filterData) {
            this.filterList.push(new FilterItem(filterData[obj]));
          }
          this.initFilterList(this.filterList);
        })
      },
      /* 初始化筛选列表 */
      initFilterList(list) {
        /* search 数据 */
        let search = {
          name: "search",
          data: {},
          event: function (e) {
            that[e.fn](e);
          }
        };
        /* 认证状态对象 */
        let authState = {
          name: "authstate",
          data: {
            title: "状态",
            stateList: [
              {
                value: "已结束",
                stateCode: 2,
                stateColor: "#47ba54",
                active: false
              },
              {
                value: "核销中",
                stateCode: 1,
                stateColor: "#ff7744",
                active: false
              },
              {
                value: "未开始",
                stateCode: 0,
                stateColor: "#a1afb3",
                active: false
              }
            ]
          },
          event: function (e) {
            that[e.fn](e);
          }
        };
        if (that.type == 'caogao') {
          list.unshift(search);
        }else {
          list.unshift(search, authState);
        }
        this.$store.commit("updateFilterList", list);
      },
      /* 重置筛选列表 */
      _reset() {
        this.title = ''
        this.status = ''
        this.communityIdList =  this.$store.state.isJiedao?'':parseInt(this.$store.state.streetorcommunityid)
        this.page = 1
        this.goodList = []
        this.newRule++
        this.getfilter()
      },
      /* ---------------------所有 筛选 业务处理 代码 如下--------------------*/

      /* ==================== 搜索  BEGIN==================== */
      search({params}) {
        this.title = params.searchValue;
        this.initList()
      },
      /* ==================== 搜索  END==================== */
      /* ==================== 认证状态  BEGIN==================== */
      authchange({params}) {
        this.status = params.stateCode; // 筛选条件更新
        this.initList()
      },
      /* 勾选筛选选项 */
      sortChange({params}) {
        this._groupChange(params);
      },
      /* ==================== 微支部  END==================== */
      /* ==================== 行政区域  BEGIN==================== */
      areaChange({ params }) {
        console.log("行政区域筛选");
        console.log(params);
        this._groupChange(params);
      },
      /* ==================== 小区  BEGIN==================== */
      comChange({params}) {
        this._groupChange(params);
      },
      /* 勾选筛选 初始化不同的属性*/
      _groupChange(e) {
        console.log(e)
        let target = this.filterList[e.filterListIndex];
        var val1 = target.data.dataList[e.selectedIndex].id
        this.communityIdList = val1
        console.log(val1)
        this.initList()
      },
    },
    created() {
      this.reset = this._.debounce(this._reset, 500); // filter 重置后会触发
      /**内容框宽度 */
      this.$nextTick(function () {
        this.contentWidth = this.$refs.wrapper.offsetWidth;
      });
      /**页面高度改变时内容框宽度 */
      window.onresize = () => {
        return (() => {
          this.contentWidth = this.$refs.wrapper && this.$refs.wrapper.offsetWidth;
        })();
      };
      
    },
    mounted() {
      that = this
      this.getfilter();
    }
  }
  /* ---------------------------筛选组件构造对象 --------------------------*/
  /*
    type : 用来确定 使用哪个组件
    name ：组件显示的头部文字
    children: 子列表数据
  */
  function FilterItem({type, name, children, selectedIndex}) {
    /* 如果是来源 获取图片路径 */

    this._getIconPath = function (type, obj) {
      if (type == "source") {
        switch (obj.type) {
          case "gzh":
            return require("../../../assets/images/filter/gzh.png");
            break;
          case "xfej":
            return require("../../../assets/images/filter/xfej.png");
            break;
          case "mst":
            return require("../../../assets/images/filter/mst.png");
            break;
          case "jczl_mst":
            return require("../../../assets/images/filter/jm.png");
            break;
          case "jczl_xfej":
            return require("../../../assets/images/filter/dy.png");
            break;
          default:
            return "";
        }
      } else {
        return "";
      }
    };
    /* 是否可编辑 以后扩展*/
    this.editMode = function (type) {
      switch (type) {
        case "category":
          return true;
          break;
        default:
          return false;
      }
    };
    /* 初始化 组件类型 this.name 确定组件类型*/
    switch (type) {
      case "category":
        this.name = "sort";
        break;
      case "party":
        this.name = "microorg";
        break;
      case "source":
        this.name = "origin";
        break;
      case "zone":
        this.name = "community";
        break;
      case "community":
        this.name = "singleDivision";
        break;
    }
    /* 对象类型 */
    this.type = type;
    /* 初始化对象 数据 */
    this.data = {
      title: name, // 解构过来的name
      edit: this.editMode(type),
      dataList: children.map((item, index) => {
        return {
          id: item.id,
          label: item.name,
          number: item.userCount,
          iconPath: this._getIconPath(type, item),
          type: item.type || ""
        };
      })
    };
    if(selectedIndex > -1) {
      console.log(111)
      this.data.selectedIndex = selectedIndex
    }
    /* 初始化对象事件 写死的 由当前组件对象去处理业务逻辑，没有相关函数会报错*/
    this.event = function (e) {
      that[e.fn](e);
    };
  }
</script>

<style scoped lang="less">
  .header-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 84px;
    line-height: 84px;
    position: relative;
    padding: 0 20px;
    .btn {
      height: 30px;
      line-height: 30px;
      width: 50px;
      text-align: center;
      background: #fff;
      color: #999;
      &:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      &:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
    .active {
      background: #ff7b44;
      color: #fff
    }
    .header {
      font-size: 25px;
      text-align: center;
    }
  }
</style>
